export const SelfServeConstant = 'Self-Serve Billing';
export const SelfRenewelConstant = 'Self-Serve Renewal';
